<template lang="pug">
v-tab-item
    feathers-vuex-find(service="vw-artists-request" :query="dataQuery" :fetchQuery="fetchQuery" :watch="['query', 'fetchQuery']")
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title Artists Request
                v-spacer
                v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )
                template(v-slot:item.full_name="{ item }")
                    v-avatar(size="30" style="margin-right: 10px;")
                        img(:src="item.profile_picture_thumb")
                    a(:href="`http://www.breakinghits.app/${item.url}`" :target="`__user-${item.id}`") {{ item.fname }} {{ item.lname }}
                template(v-slot:item.date_created="{ item }") {{ item.date_created | dateFormat }}
                template(v-slot:item.status="{ item }") {{ item.status | status }}
                template(v-slot:item.actions="{ item }")
                    div(v-if="item.status === 0")
                        a(href="javascript:void(0);" @click="openLink(item.id, `__user-${item.id}`, item.accept_link)" style="color: green; text-decoration: none;") Accept
                        | &nbsp;|&nbsp;
                        a(href="javascript:void(0);" @click="openLink(item.id, `__user-${item.id}`, item.decline_link)" style="color: red; text-decoration: none;") Deny
                    div(v-else) ---

</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            searchUser: '',
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Full Name',
                    align: 'start',
                    sortable: true,
                    value: 'full_name'
                },
                {
                    text: 'Status',
                    align: 'start',
                    sortable: true,
                    value: 'status'
                },
                {
                    text: 'Date Requested',
                    align: 'end',
                    sortable: true,
                    value: 'date_created'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    sortable: false,
                    value: 'actions'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['date_created'],
                sortDesc: [true]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Waiting for approval';
                case 1: return 'Approved';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { fname: { $like: `%${this.searchUser}%` } },
                        { lname: { $like: `%${this.searchUser}%` } },
                        { url: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { fname: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                        { lname: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                        { url: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.fname = this.pagination.sortDesc[index] ? -1 : 1;
                            $sort.lname = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        openLink(id, name, link) {
            window.open(link, name);
            setTimeout(() => {
                this.getArtistRequest(id);
            }, 5000);
        },
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        ...mapActions('vw-artists-request', { 'getArtistRequest': 'get' })
    }
}
</script>